import { Select } from 'antd';

import {
  CustomDropdown,
  CustomInput,
  CustomInputMobile,
  CustomLabel,
  CustomLabelMobile,
  StyledFormItem,
} from '@components/onboarding/form/steps/styles';
import {
  getWardrobeOptionsUK,
  MinMaxValuesUK,
  WardrobeLabelUK,
} from '@lib/utils/constants';

const { Option } = Select;

type Props = {
  label: string;
  userAppearance: any;
  handleWardrobeChange: any;
  isMobile?: boolean;
  isMinor: boolean;
};

export const WardrobeQuestionUK = ({
  label,
  userAppearance,
  handleWardrobeChange,
  isMobile = false,
  isMinor,
}: Props): JSX.Element => {
  const wardrobeOptionsUK = getWardrobeOptionsUK(label);
  return (
    <>
      {isMobile ? (
        <CustomLabelMobile label={WardrobeLabelUK[label]} requiredSymbol />
      ) : (
        <CustomLabel label={WardrobeLabelUK[label]} requiredSymbol />
      )}
      <StyledFormItem
        name={label}
        initialValue={userAppearance[label]}
        rules={[
          {
            required: true,
            message: wardrobeOptionsUK
              ? `${WardrobeLabelUK[label]} selection required`
              : `${WardrobeLabelUK[label]} must be between ${MinMaxValuesUK[label].min} and ${MinMaxValuesUK[label].max}`,
            validator: (_, value) => {
              // Check if the input field is a CustomInput
              if (!wardrobeOptionsUK) {
                // This is a CustomInput
                const regex = /^[0-9]*$/;
                if (!regex.test(value)) {
                  return Promise.reject('Only numeric characters are allowed.');
                }

                const intValue = parseInt(value, 10);
                if (
                  intValue >= MinMaxValuesUK[label].min &&
                  intValue <= MinMaxValuesUK[label].max
                ) {
                  return Promise.resolve();
                } else {
                  return Promise.reject(
                    `${label} size must be between ${MinMaxValuesUK[label].min} and  ${MinMaxValuesUK[label].max}.`
                  );
                }
              } else {
                // This is a Dropdown
                if (!value) return Promise.reject();
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        {wardrobeOptionsUK ? (
          <CustomDropdown
            isMobile={isMobile}
            placeholder='Select Size'
            onChange={(value) => {
              handleWardrobeChange(label, value);
            }}
          >
            {wardrobeOptionsUK.map((option, i) => (
              <Option key={`${option}${i}`} value={option}>
                {option}
              </Option>
            ))}
          </CustomDropdown>
        ) : isMobile ? (
          <CustomInputMobile
            placeholder='Type here'
            onChange={(event) => {
              handleWardrobeChange(label, event.target.value);
            }}
          />
        ) : (
          <CustomInput
            placeholder='Type here'
            onChange={(event) => {
              handleWardrobeChange(label, event.target.value);
            }}
          />
        )}
      </StyledFormItem>
    </>
  );
};
